<template>
  <div class="card-container">
    <common-el-form
      :model="model"
      :rules="rules"
      :submitData="submitData"
      @success="onSuccess"
      @cancel="onCancel"
      submit-btn-text="提交"
      failTitle="提交失败"
      loadingText="提交中..."
      :submitService="submitService"
      labelWidth="110px"
      ref="model"
    >
      <!--<el-form-item label="机构简称" prop="tatSimpleId">-->
      <!--<el-select v-model="model.tatSimpleId" style="width: 300px">-->
      <!--<el-option-->
      <!--v-for="item in tatSimpleNames"-->
      <!--:key="item.id"-->
      <!--:label="item.simpleName"-->
      <!--:value="item.id">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->
      <select-organs
        v-model="model.tatSimpleId"
        :selectValue="model.tatSimpleId"
        :multiple="!$route.params.id"
        :collapseTags="!$route.params.id"
        :needAll="false"
        selectWidth="300px"
      ></select-organs>
      <p class="commonTitle">还款配置</p>
      <!--<el-form-item label="通道简称" prop="chnId">-->
      <!--<el-select v-model="model.chnId" style="width: 300px">-->
      <!--<el-option-->
      <!--v-for="item in shortNames"-->
      <!--:key="item.id"-->
      <!--:label="item.shortName"-->
      <!--:value="item.id">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->
      <!--<el-form-item label="支付类型" prop="payType">-->
      <!--<el-select v-model="model.payType" style="width: 300px">-->
      <!--<el-option-->
      <!--v-for="item in payTypes"-->
      <!--:key="item.dictKey"-->
      <!--:label="item.dictValue"-->
      <!--:value="item.dictKey">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->

      <el-form-item label="通道名称" prop="chnName">
        <el-select v-model="model.chnName" filterable style="width: 300px">
          <el-option
            v-for="item in chnNameList"
            :key="item.id"
            :label="item.chnName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择路线" prop="lineCode">
        <el-select
          v-model="model.lineCode"
          style="width: 300px"
          :disabled="!model.chnName"
          @focus="handleLine"
        >
          <el-option
            v-for="item in shortNames"
            :key="item.id"
            :label="item.shortName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="配置权重" prop="weight">
        <el-input-number
          :step="1"
          :min="0"
          :controls="false"
          v-model="model.weight"
          style="width: 300px"
          step-strictly
        ></el-input-number>
      </el-form-item>

      <el-form-item label="结算类型" prop="settleType">
        <el-select v-model="model.settleType" style="width: 300px">
          <el-option
            v-for="item in settleTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!--<el-form-item label="手续费类型" prop="feeType">-->
      <!--<el-select v-model="model.feeType" style="width: 300px">-->
      <!--<el-option-->
      <!--v-for="item in feeTypes"-->
      <!--:key="item.dictKey"-->
      <!--:label="item.dictValue"-->
      <!--:value="item.dictKey">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->
      <el-row>
        <!--<el-form-item label="代付收费类型" prop="repayType">-->
        <!--<el-select v-model="model.repayType" style="width: 300px">-->
        <!--<el-option-->
        <!--v-for="item in repayTypes"-->
        <!--:key="item.dictKey"-->
        <!--:label="item.dictValue"-->
        <!--:value="item.dictKey">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--</el-form-item>-->
      </el-row>
      <el-form-item label="快捷收费标准" prop="feeAmt">
        <div class="flex-row">
          <el-input-number
            v-model="model.feeAmt"
            controls-position="right"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            style="width: 300px"
            @change="feeAmtChange"
          ></el-input-number>
          <span class="formSpan">%</span>
        </div>
      </el-form-item>
      <el-form-item
        label="试用期收费标准"
        prop="feeAmtProbation"
        label-width="121px"
      >
        <div class="flex-row">
          <el-input-number
            v-model="model.feeAmtProbation"
            controls-position="right"
            :precision="2"
            :step="0.1"
            :controls="false"
            :min="0"
            style="width: 289px"
          ></el-input-number>
          <span class="formSpan">%</span>
        </div>
      </el-form-item>
      <el-row>
        <el-form-item label="代付收费标准" prop="repayAmt">
          <div class="flex-row">
            <el-input-number
              controls-position="right"
              :precision="2"
              :step="0.1"
              :min="0"
              :controls="false"
              v-model="model.repayAmt"
              style="width: 300px"
            ></el-input-number>
            <span class="formSpan">元</span>
          </div>
        </el-form-item>
      </el-row>
      <!--<el-row>-->
      <!--<el-form-item label="单笔交易最小额" prop="singleMinAmt">-->
      <!--<div class="flex-row">-->
      <!--<el-input-number controls-position="right" :precision="2" :step="0.1" :min="0" :controls="false"-->
      <!--v-model="model.singleMinAmt" style="width: 300px"></el-input-number>-->
      <!--<span class="formSpan">元/笔</span>-->
      <!--</div>-->
      <!--</el-form-item>-->
      <!--<el-form-item label="单笔交易最大额" prop="singleMaxAmt">-->
      <!--<div class="flex-row">-->
      <!--<el-input-number controls-position="right" :precision="2" :step="0.1" :min="0" :controls="false"-->
      <!--v-model="model.singleMaxAmt" style="width: 300px"></el-input-number>-->
      <!--<span class="formSpan">元/笔</span>-->
      <!--</div>-->
      <!--</el-form-item>-->
      <!--</el-row>-->
      <!--<el-row>-->
      <!--<el-form-item label="单日累计金额" prop="dayTotalAmt">-->
      <!--<div class="flex-row">-->
      <!--<el-input-number controls-position="right" :precision="2" :step="0.1" :min="0" :controls="false"-->
      <!--v-model="model.dayTotalAmt" style="width: 300px"></el-input-number>-->
      <!--<span class="formSpan">元</span>-->
      <!--</div>-->
      <!--</el-form-item>-->
      <!--<el-form-item label="单日累计笔数" prop="dayTotalCount">-->
      <!--<div class="flex-row">-->
      <!--<el-input-number controls-position="right" :min="0" v-model="model.dayTotalCount"  :step="1" step-strictly :controls="false"-->
      <!--style="width: 300px"></el-input-number>-->
      <!--<span class="formSpan">笔</span>-->
      <!--</div>-->
      <!--</el-form-item>-->
      <!--</el-row>-->
      <!--<el-row>-->
      <!--<el-form-item label="交易时间" prop="transaction">-->
      <!--&lt;!&ndash;<p>{{transaction}}</p>&ndash;&gt;-->
      <!--<el-time-picker-->
      <!--is-range-->
      <!--arrow-control-->
      <!--v-model="transaction"-->
      <!--range-separator="至"-->
      <!--value-format="HH:mm:ss"-->
      <!--start-placeholder="开始时间"-->
      <!--end-placeholder="结束时间"-->
      <!--placeholder="选择时间范围">-->
      <!--</el-time-picker>-->
      <!--</el-form-item>-->
      <!--</el-row>-->
      <!--<el-row>-->
      <!--<el-form-item label="允许交易日期" prop="allowTranType">-->
      <!--<div class="flex-row vertical-center">-->
      <!--<el-radio v-model="model.allowTranType" label="0" class="commonMargin">不限</el-radio>-->
      <!--<div class="flex-row vertical-center">-->
      <!--<el-radio v-model="model.allowTranType" label="1" class="commonMargin">起止</el-radio>-->
      <!--<el-date-picker-->
      <!--v-model="allowTransaction"-->
      <!--:disabled="dateAllow"-->
      <!--type="daterange"-->
      <!--value-format="yyyy-MM-dd"-->
      <!--range-separator="至"-->
      <!--start-placeholder="开始日期"-->
      <!--end-placeholder="结束日期">-->
      <!--</el-date-picker>-->
      <!--</div>-->
      <!--</div>-->
      <!--</el-form-item>-->
      <!--</el-row>-->
      <el-form-item label="备注">
        <el-input
          maxlength="80"
          show-word-limit
          v-model="model.remark"
          type="textarea"
          resize="none"
          rows="5"
          style="width: 300px"
        ></el-input>
      </el-form-item>
    </common-el-form>
  </div>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";
import OrganService from "service/OrganService";
import OrganRateService from "service/OrganRateService";
import SelectOrgans from "components/business/SelectOrgans";
import ChannelService from "service/ChannelService";
import ChannelRateService from "service/ChannelRateService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "AddOrganRate",
  data() {
    return {
      rules: {
        // weight: [{
        //     required: true,
        //     message:'请配置权重'
        // },],
        tatSimpleId: [
          {
            required: true,
            message: "请选择机构简称",
          },
        ],
        chnName: [
          {
            required: true,
            message: "请选择通道代码",
          },
        ],
        lineCode: [
          {
            required: true,
            message: "请选择路线",
          },
        ],
        settleType: [
          {
            required: true,
            message: "请选择结算类型",
          },
        ],
        feeAmt: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入"));
              } else if (value >= 1) {
                if (this.model.feeType == 1) {
                  callback(new Error("快捷收费标准不能大于或等于1"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
          },
        ],
        feeAmtProbation: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入"));
              } else if (
                this.model.feeAmtProbation < this.model.feeAmt &&
                this.model.feeAmtProbation != this.model.feeAmt
              ) {
                callback(new Error("试用期收费标准不能小于快捷收费标准"));
              } else {
                callback();
              }
            },
          },
        ],
        repayAmt: [
          {
            required: true,
            message: "请输入代付收费标准",
          },
        ],
      },
      rePayShow: true,
      model: {
        weight: "",
        tatSimpleId: "",
        shortName: "",
        chnId: "",
        chnName: "",
        payType: "",
        settleType: "",
        feeType: "1",
        feeAmt: "",
        feeAmtProbation: "",
        tranStartTime: "开始日期",
        tranEndTime: "结束日期",
        allowTranType: "0",
        allowStartDate: "开始日期",
        allowEndDate: "结束日期",
        tranCycleType: "0",
        tranCycleDtl: [],
        needRepay: "0",
        repayType: "1",
        repayAmt: "",
        singleMinAmt: "",
        singleMaxAmt: "",
        dayTotalAmt: "",
        dayTotalCount: "",
      },
      transaction: ["", ""],
      allowTransaction: [],
      days: [
        {
          value: "1",
          label: "周一",
        },
        {
          value: "2",
          label: "周二",
        },
        {
          value: "3",
          label: "周三",
        },
        {
          value: "4",
          label: "周四",
        },
        {
          value: "5",
          label: "周五",
        },
        {
          value: "6",
          label: "周六",
        },
        {
          value: "7",
          label: "周七",
        },
      ],
      shortNames: [],
      chnNameList: [],
      payTypes: [],
      settleTypes: [],
      feeTypes: [],
      repayTypes: [],
      needRepays: [
        {
          value: "0",
          label: "需要",
        },
        {
          value: "1",
          label: "不需要",
        },
      ],
      dateAllow: true,
      weekAllow: true,
      organId: "",
      getShortName: "",
      params: {},
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    CommonElForm,
    SelectOrgans,
  },
  mounted() {
    this.getTypeNames("payType", (res) => {
      this.payTypes = res;
    });
    this.getTypeNames("settleType", (res) => {
      this.settleTypes = res;
    });
    this.getTypeNames("feeType", (res) => {
      this.feeTypes = res;
    });
    this.getTypeNames("repayType", (res) => {
      this.repayTypes = res;
    });
    this.getchnNameList();

    this.organId = this.$route.params.id;

    if (this.organId != undefined) {
      this.getDetail();
    }
  },
  computed: {
    submitData() {
      if (this.model.tranCycleDtl == null || this.model.tranCycleDtl == "") {
        this.model.tranCycleDtl = [];
      }
      if (this.transaction == null || this.transaction == "") {
        this.transaction = [];
      }

      if (this.allowTransaction == null || this.allowTransaction == "") {
        this.allowTransaction = [];
      }

      this.params = {
        tatSimpleId: this.model.tatSimpleId.toString(),
        chnId: this.model.chnName,
        lineCode: this.model.lineCode,
        weight: this.model.weight,

        // payType: this.model.payType,
        settleType: this.model.settleType,
        // feeType: this.model.feeType,
        feeAmt: this.model.feeAmt,
        feeAmtProbation: this.model.feeAmtProbation,
        singleMinAmt:
          this.model.singleMinAmt == undefined ? 0 : this.model.singleMinAmt,
        singleMaxAmt:
          this.model.singleMaxAmt == undefined ? 0 : this.model.singleMaxAmt,
        dayTotalAmt:
          this.model.dayTotalAmt == undefined ? 0 : this.model.dayTotalAmt,
        dayTotalCount:
          this.model.dayTotalCount == undefined ? 0 : this.model.dayTotalCount,
        tranStartTime: this.transaction[0],
        tranEndTime: this.transaction[1],
        allowTranType: this.model.allowTranType,
        allowStartDate: this.allowTransaction[0],
        allowEndDate: this.allowTransaction[1],
        tranCycleType: this.model.tranCycleType,
        tranCycleDtl: this.model.tranCycleDtl,
        needRepay: this.model.needRepay,
        // repayType: this.model.repayType,
        repayAmt: this.model.repayAmt,
        remark: this.model.remark,
        userId: this.userId,
      };
      if (this.transaction[0] == "" || this.transaction[0] == undefined) {
        delete this.params.tranStartTime;
        delete this.params.tranEndTime;
      }
      if (this.allowTransaction.length == 0) {
        delete this.params.allowStartDate;
        delete this.params.allowEndDate;
      }
      if (this.model.tranCycleDtl.length == 0) {
        delete this.params.tranCycleDtl;
      }
      if (this.model.remark == "" || this.model.remark == undefined) {
        delete this.params.remark;
      }
      if (this.model.needRepay == 1) {
        delete this.params.repayType;
        delete this.params.repayAmt;
      }
      if (this.organId) {
        this.params.id = this.organId;
      }

      return this.params;
    },
    submitService() {
      if (this.organId) {
        return OrganRateService.update;
      } else {
        return OrganRateService.add;
      }
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {
    // 'model.feeType'(val,oldVal){
    //     if (oldVal) {
    //         this.model.feeAmt = '0';
    //         this.model.repayAmt = '0';
    //     }
    // },
    "model.chnName"(val) {
      // this.getShortNames();
      this.getShortNames(
        "",
        (res) => {
          this.shortNames = res;
        },
        val
      );
    },
    "model.needRepay"(val) {
      this.rePayShow = val == 1 ? true : false;
    },
    // 'model.allowTranType'(val) {
    //     if (val == 1) {
    //         this.dateAllow = false;
    //     } else {
    //         this.dateAllow = true;
    //     }
    // },
    // 'model.tranCycleType'(val) {
    //     if (val == 1) {
    //         this.weekAllow = false;
    //     } else {
    //         this.weekAllow = true;
    //     }
    // },
  },
  methods: {
    getDetail() {
      const params = {
        id: this.organId,
        userId: this.userId,
      };

      this.doLoad(
        OrganRateService.detail,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            let result = res.contents;
            this.model = result;

            this.getShortName = this.model.shortName;
            if (this.model.tranCycleDtl == null) {
              this.model.tranCycleDtl = [];
            } else {
              this.model.tranCycleDtl = this.model.tranCycleDtl.split(",");
            }
            // this.model.tranCycleType = this.model.tranCycleType.toString();
            // this.model.allowTranType = this.model.allowTranType.toString();
            this.model.tatSimpleId = this.model.tatSimpleId.toString();
            this.model.settleType = this.model.settleType.toString();
            this.model.needRepay = this.model.needRepay.toString();
            // this.model.feeAmt = this.model.feeAmt / 100;
            this.model.singleMaxAmt = (this.model.singleMaxAmt * 100) / 10000;
            this.model.singleMinAmt = (this.model.singleMinAmt * 100) / 10000;
            this.model.repayAmt = (this.model.repayAmt * 100) / 10000;
            if (this.model.allowStartDate == null) {
              this.allowTransaction = [];
            } else {
              this.allowTransaction.push(
                this.model.allowStartDate,
                this.model.allowEndDate
              );
            }

            if (
              this.model.tranStartTime == null ||
              this.model.tranEndTime == null ||
              this.model.tranStartTime == "" ||
              this.model.tranEndTime == ""
            ) {
              this.transaction = ["", ""];
            } else {
              this.transaction = [
                this.model.tranStartTime,
                this.model.tranEndTime,
              ];
            }
            // this.transaction = [this.model.tranStartTime,this.model.tranEndTime];
            // this.transaction[1] = this.model.tranEndTime;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      if (res.respCode == "0000") {
        this.showSuccess(res.respMsg);
        this.$router.back();
      } else {
        this.showError(res.respMsg);
      }
    },
    onCancel() {
      this.$router.back();
    },
    handleLine() {
      if (!this.model.chnName) {
        this.showWarming("请优先选择通道名称");
        return;
      }
    },
    feeAmtChange() {
      this.$refs.model.validateField("feeAmtProbation");
    },
    // getShortNames() {
    //
    //     this.doLoad(ChannelRateService.shortNames, {
    //         chnId : this.model.chnName
    //     }, res => {
    //         this.doCheck(res, res => {
    //             this.shortNames = res.contents;
    //         });
    //     }, '信息获取失败')
    // },
    getchnNameList() {
      this.doLoad(
        ChannelService.names,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.chnNameList = res.contents;
          });
        },
        "信息获取失败"
      );
    },
  },
};
</script>

<style scoped>
.el-form-item {
  display: flex;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/AddOrganRate.vue